import { Navigate, Outlet } from "react-router-dom";
import { useBankingAccess } from "@/hooks/useBankingAccess";

/**
 * Route guard for /banking. Blocks cashier/viewer/no-membership sessions
 * BEFORE the Banking page mounts, so no bank_deposits or cash_movements
 * queries are issued for those users. See finding F-12.
 */
export function RequireBankingAccess() {
  const { canView, loading } = useBankingAccess();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground text-sm">
        Loading…
      </div>
    );
  }
  if (!canView) return <Navigate to="/" replace />;
  return <Outlet />;
}